import { brand } from '@se-freshman-digital-2026/shared/brand'

export const primaryLogoUrl = brand.primaryLogoUrl
